module.exports = __webpack_public_path__ + "static/img/shareBg.c0f41b50.jpg";